import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  initial: 'V',
  name: 'Valentina S.',
  location: 'Buenos Aires',
  role: 'Fonoaudióloga en consulta privada',
  quote: '"Armé mi primer protocolo de anamnesis completo en una tarde. Antes de cada sesión sé exactamente qué preguntar, qué test usar y cómo registrar. Nunca más llego al consultorio sin saber por dónde empezar."'
}, {
  initial: 'L',
  name: 'Lucía M.',
  location: 'Rosario',
  role: 'Fonoaudióloga pediátrica',
  quote: '"El árbol de decisión de instrumentos cambió todo. En 2 semanas de aplicarlo ya elegía los tests con criterio clínico real. Dejé de adivinar y empecé a evaluar con seguridad."'
}, {
  initial: 'C',
  name: 'Camila R.',
  location: 'Córdoba',
  role: 'Fonoaudióloga en consultorio propio',
  quote: '"Redacto mis informes en 30 minutos con las plantillas del kit. Antes me llevaba 2 horas y nunca me parecían suficientemente profesionales. Ahora los entrego con confianza."'
}];
export function Testimonials() {
  return <section className="py-10 md:py-16 px-4 md:px-8 bg-white" data-id="element-290">
      <div className="max-w-7xl mx-auto" data-id="element-291">
        <div className="flex md:grid md:grid-cols-3 gap-4 md:gap-8 overflow-x-auto md:overflow-visible snap-x snap-mandatory md:snap-none -mx-4 px-4 md:mx-0 md:px-0 pb-4 md:pb-0 scrollbar-hide" data-id="element-292">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream p-6 md:p-8 rounded-2xl border border-teal-900/10 shadow-sm flex flex-col h-full min-w-[85%] md:min-w-0 snap-center" data-id="element-293">
              <div className="flex text-amber-400 mb-3 md:mb-4" data-id="element-294">
                {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} fill="currentColor" data-id="element-295" />)}
              </div>
              <p className="text-slate-700 italic mb-4 md:mb-6 flex-grow text-base md:text-lg leading-relaxed" data-id="element-296">
                {t.quote}
              </p>
              <div className="flex items-center gap-3 md:gap-4 mt-auto" data-id="element-297">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-teal-100 text-teal-900 rounded-full flex items-center justify-center font-serif font-bold text-lg md:text-xl" data-id="element-298">
                  {t.initial}
                </div>
                <div data-id="element-299">
                  <h4 className="font-bold text-teal-900 text-sm md:text-base" data-id="element-300">
                    {t.name}
                  </h4>
                  <p className="text-xs md:text-sm text-slate-500" data-id="element-301">
                    {t.location} — {t.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
        <p className="md:hidden text-center text-xs text-slate-400 mt-2 font-medium" data-id="element-302">
          Deslizá para ver más →
        </p>
      </div>
    </section>;
}